import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-validate-component',
  templateUrl: './validate-component.component.html',
  styleUrls: ['./validate-component.component.scss']
})
export class ValidateComponentComponent implements OnInit {
  @Input() employeesArrayList: any;
  @Input() showAllowedEmployees: any;
  
  functionsList: any = [];
  selectedFunctions = [];
  searchText: any;

  constructor() { }

  ngOnInit(): void {
  }

  fetchSelectedItems() {
    this.selectedFunctions = this.functionsList.filter((value, index) => {
      return value.isSelected
    });
    //this.selectedItemsList.emit(this.selectedFunctions)
  }
  

}
